import ToastV2 from '@shared/components/base/BaseToast';
import i18n from '@shared/i18n';

import logger from '../logger';
import { LOGGER_SPACIAL_SYMBOL } from '../config';
import { landingBack } from '@shared/i18n/route';

export const handleOnReactError = (e: Error, callback?: AnyFunc) => {
	callback && callback();

	if (
		e.message.includes('Failed to fetch dynamically imported module') ||
		e.message.includes('Unable to preload CSS')
	) {
		ToastV2.error(i18n.get('Module_Loading_Failed_Toast'));
	}
	logger.error(LOGGER_SPACIAL_SYMBOL.GLOBAL, 'REACT_ERROR', e);
	landingBack('/error');
};
